import UserRolesForm from '../../src/components/_forms/UserRolesForm';
import {withRouterApi} from '../../src/HOCs/withRouterApi';
import {FormViewProps} from '../../src/@types/components/FormViewProps';
import {UserRolesFormModel} from '../../src/@types/components/UserRolesForm';
import {CreateView} from '../../src/components/_views/configurable/CreateView';

export class UserRolesCreateFormPage extends CreateView<UserRolesFormModel> {
    protected getFormComponent() {
        return UserRolesForm as any;// todo: somehow fix typescript error
    }
}

export default UserRolesCreateFormPage.getStoreConnector()(withRouterApi<FormViewProps>(UserRolesCreateFormPage));
